module.exports = __webpack_public_path__ + "img/14.1.7926218f.jpg";